export const STATE_SLICE = '@flopflip';
